import React from 'react';
import * as Yup from 'yup';
import MasterManager from '../../components/expense/MasterManager';
import useExpenseLookups, { withCurrent } from '../../components/expense/useExpenseLookups';

const schema = Yup.object().shape({
  name: Yup.string().trim().required('Name is required').max(100),
  iso2: Yup.string().trim().required('ISO2 is required').matches(/^[A-Za-z]{2}$/, 'ISO2 must be 2 letters'),
  iso3: Yup.string().trim().matches(/^[A-Za-z]{3}$/, { message: 'ISO3 must be 3 letters', excludeEmptyString: true }),
});

// Owner: HR admin
const CountryMaster = ({ canEdit }) => {
  const { currencies } = useExpenseLookups(canEdit ? ['currencies'] : []);

  return (
    <MasterManager
      resource="countries"
      title="Country"
      canEdit={canEdit}
      searchPlaceholder="Search name / ISO code"
      columns={[
        { key: 'name', label: 'Name' },
        { key: 'iso2', label: 'ISO2' },
        { key: 'iso3', label: 'ISO3' },
        { key: 'defaultCurrency', label: 'Default Currency' },
        { key: 'isOperatingCountry', label: 'Operating', render: (r) => (r.isOperatingCountry ? 'Yes' : 'No') },
      ]}
      fields={(editing) => [
        { name: 'name', label: 'Name', required: true },
        { name: 'iso2', label: 'ISO2', required: true, xs: 6, inputProps: { maxLength: 2 } },
        { name: 'iso3', label: 'ISO3', xs: 6, inputProps: { maxLength: 3 } },
        { name: 'defaultCurrency', label: 'Default Currency', type: 'select', options: withCurrent(currencies, editing?.defaultCurrency) },
        { name: 'isOperatingCountry', label: 'Operating country', type: 'switch' },
      ]}
      validationSchema={schema}
      emptyValues={{ name: '', iso2: '', iso3: '', defaultCurrency: '', isOperatingCountry: false }}
      toForm={(r) => ({
        name: r.name || '',
        iso2: r.iso2 || '',
        iso3: r.iso3 || '',
        defaultCurrency: r.defaultCurrency || '',
        isOperatingCountry: Boolean(r.isOperatingCountry),
      })}
      toPayload={(v) => ({
        name: v.name,
        iso2: v.iso2,
        iso3: v.iso3,
        defaultCurrency: v.defaultCurrency,
        isOperatingCountry: Boolean(v.isOperatingCountry),
      })}
    />
  );
};

export default CountryMaster;
